import { styled, GetProps, Text as TamaguiText } from 'tamagui'

export const Heading = styled(TamaguiText, {
  name: 'Heading',
  tag: 'h1',
  
  // Base styles - Kinetic Typography
  fontFamily: '$heading',
  fontWeight: '800',
  textTransform: 'uppercase',
  letterSpacing: -1,
  color: '$color',
  
  variants: {
    size: {
      hero: {
        fontSize: 80,
        lineHeight: 88,
        letterSpacing: -3,
      },
      xl: {
        fontSize: 48,
        lineHeight: 56,
        letterSpacing: -2,
      },
      lg: {
        fontSize: 32,
        lineHeight: 40,
        letterSpacing: -1.5,
      },
      md: {
        fontSize: 24,
        lineHeight: 32,
        letterSpacing: -1,
      },
      sm: {
        fontSize: 18,
        lineHeight: 24,
        letterSpacing: -0.5,
      },
      xs: {
        fontSize: 14,
        lineHeight: 20,
        letterSpacing: 0,
      },
    },
    level: {
      h1: { tag: 'h1' },
      h2: { tag: 'h2' },
      h3: { tag: 'h3' },
      h4: { tag: 'h4' },
      h5: { tag: 'h5' },
      h6: { tag: 'h6' },
    },
  } as const,
  
  defaultVariants: {
    size: 'lg',
    level: 'h1',
  },
})

export type HeadingProps = GetProps<typeof Heading>
